export default {
    methods: {
        uniqid() {
            return `_${Math.random().toString(36).substr(2, 9)}`;
        },
    },
};



// WEBPACK FOOTER //
// ./src/mixins/uniqid.js